import "../../style/rangeBar.css";
import { Pointer } from "../svg-organizer/SvgOrganizer";
import { Tooltip } from "antd";
import { SmallCircle } from "../index";
import { useState } from "react";

const RangeBar = ({
  dataset = [{ label: "", score: null, labelColor: "", pointerScore: "" }],
  legends = true,
}) => {
  const [barRange, setBarRange] = useState([
    {
      startRange: 0,
      endRange: 549,
      backgroundColor: "#FC3C42",
      color: "#FFFFFF",
      pointerScore: [],
      category: "Below Average",
      left: "3%",
    },
    {
      startRange: 550,
      endRange: 624,
      backgroundColor: "#F7A64F",
      color: "#FFFFFF",
      pointerScore: [],
      category: "Okay",
      left: "1.2%",
    },
    {
      startRange: 625,
      endRange: 699,
      backgroundColor: "#F2E103",
      color: "#161616",
      pointerScore: [],
      category: "Good",
      left: "-0.6%",
    },
    {
      startRange: 700,
      endRange: 799,
      backgroundColor: "#7EBB1B",
      color: "#FFFFFF",
      pointerScore: [],
      category: "Very Good",
      left: "-2.4%",
    },
    {
      startRange: 800,
      endRange: 1000,
      backgroundColor: "#1bbb6b",
      color: "#FFFFFF",
      pointerScore: [],
      category: "Excellent",
      left: "-4.2%",
    },
  ]);

  const [runOnce, setRunOnce] = useState(true);

  const toolTipContent = (
    label,
    labelColor,
    score,
    backgroundColor,
    category
  ) => {
    return (
      <div className="d-flex flex-column gap-1">
        <div className="d-flex align-items-center justify-content-center gap-2">
          <SmallCircle color={labelColor} size="12px" />
          <span
            className="fw-semibold fs14px text-center"
            style={{ color: backgroundColor }}
          >
            {label}
          </span>
        </div>
        <span className="fs14px fw-semibold">
          Score: <span style={{ color: backgroundColor }}>{score}</span>
        </span>
        <span
          className="fs14px fw-semibold text-center"
          style={{ color: backgroundColor }}
        >
          {category}
        </span>
      </div>
    );
  };

  const checkScoreRange = (scoreData) => {
    const updatedBarRange = barRange.map((range) => {
      if (
        scoreData.score >= range.startRange &&
        scoreData.score <= range.endRange
      ) {
        const pointerScore = `${
          ((scoreData.score - range.startRange) /
            (range.endRange - range.startRange)) *
            100 +
          1
        }%`;

        return {
          ...range,

          ...range.pointerScore.push({
            ...scoreData,
            pointerScore: pointerScore,
          }),
        };
      } else {
        return { ...range, range };
      }
    });

    setBarRange(updatedBarRange);
  };

  if (runOnce) {
    dataset.map((scoreData) => {
      checkScoreRange(scoreData);
      return 0;
    });
    setRunOnce(false);
  }

  return (
    <>
      <div className="d-flex flex-column w-100 gap-3  align-items-center justify-content-center">
        <div className="d-flex  rounded-pill   w-100  ">
          {barRange.map(
            (
              {
                startRange,
                endRange,
                category,
                color,
                backgroundColor,
                left,
                pointerScore,
              },
              key
            ) => (
              <div
                key={key}
                className="d-flex flex-column position-relative  gap-2 "
                style={{
                  left: left,
                  width: "100%",

                  zIndex: `${key === 0 ? "100" : `${100 - key}`}`,
                }}
              >
                <div className="d-flex align-items-center position-relative pb-2 ">
                  {pointerScore.map(
                    ({ labelColor, pointerScore, label, score }, key) => (
                      <Tooltip
                        key={key}
                        title={toolTipContent(
                          label,
                          labelColor,
                          score,
                          backgroundColor,
                          category
                        )}
                        overlayStyle={{
                          width: "auto",
                          backgroundColor: "#000",
                        }}
                        overlayClassName="rounded-3"
                        overlayInnerStyle={{ backgroundColor: "#000" }}
                      >
                        <span
                          className="position-absolute cursor-pointer  "
                          style={{
                            left: pointerScore,

                            width: "8px",
                          }}
                        >
                          {pointerScore?.length > 0 && (
                            <Pointer color={labelColor} />
                          )}
                        </span>
                      </Tooltip>
                    )
                  )}
                </div>

                <span
                  className="w-100   text-center fw-semibold py-1  rangebar-rounded "
                  style={{
                    backgroundColor: backgroundColor,
                    color: color,
                    height: "22px",
                    fontSize: "11px",
                  }}
                >
                  {startRange}-{endRange}
                </span>

                <span
                  className="text-center fs12px "
                  style={{ color: "#7D7D7D" }}
                >
                  {category}
                </span>
              </div>
            )
          )}
        </div>

        {legends && (
          <div
            className="d-flex justify-content-center align-items-center gap-4 "
            style={{ width: "85%" }}
          >
            {dataset.map(({ labelColor, label }, key) => (
              <div key={key} className="d-flex gap-3 align-items-center">
                <SmallCircle color={labelColor} size="11px" />
                <span className="fs14px fw-medium">{label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default RangeBar;
